import { Suspense } from "react";
import { useIntl } from "react-intl";

import Suspender from "lib/Suspender";

import { LoadingSkeleton } from "@joor/design-system";
import { asMaybeNumber } from "lib/conversions";
import { WorkspaceFinancialsPriceLevelFragment } from "operations";
import { StyledContent, StyledLabel, StyledTitle } from "./styledComponents";

type PriceLevel = Omit<WorkspaceFinancialsPriceLevelFragment, "id">;

type Props = {
  loading: boolean;
  rollup: PriceLevel[] | undefined;
  moreCurrencies: boolean;
};
export const ExtendedRetail = (props: Props) => {
  const intl = useIntl();

  const listExtendedRetail =
    props.rollup &&
    props.rollup.map((pl) => {
      const parsedRetail = asMaybeNumber(pl.extRetail);
      const parsedCurrency = pl.currencyCode;
      return (
        <StyledTitle data-testid="ext-retail-value">
          {parsedRetail !== undefined && parsedCurrency !== undefined
            ? intl.formatNumber(parsedRetail, {
                style: "currency",
                currency: parsedCurrency,
              })
            : "-"}
        </StyledTitle>
      );
    });

  const extendedRetail =
    props?.rollup && props.rollup[0]
      ? asMaybeNumber(props.rollup[0].extRetail)
      : 0;
  const currencyCode =
    props.rollup && props.rollup[0] && props.rollup[0].currencyCode;

  return (
    <StyledContent>
      <StyledLabel>Final Ext. Retail</StyledLabel>
      <Suspense fallback={<LoadingSkeleton />}>
        <Suspender suspend={props.loading}>
          {props.moreCurrencies ? (
            listExtendedRetail
          ) : (
            <StyledTitle data-testid="ext-retail-value">
              {extendedRetail !== undefined && currencyCode !== undefined
                ? intl.formatNumber(extendedRetail, {
                    style: "currency",
                    currency: currencyCode,
                  })
                : "-"}
            </StyledTitle>
          )}
        </Suspender>
      </Suspense>
    </StyledContent>
  );
};
